export const getAllocationMarketplaceContract = () => {
  return '0x9ECF19266921829c3Aa72722586e42E8d9Df5492'
}